// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".section .form-item-350[data-v-0eb322ca]  .el-form-item__content {\n  width: 350px;\n}\n.section .form-item-450[data-v-0eb322ca]  .el-form-item__content {\n  width: 450px;\n}\n.section .margin-Right50[data-v-0eb322ca] {\n  margin-right: 50px;\n}\n", ""]);
// Exports
module.exports = exports;
